import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5daee5ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = { class: "fs-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-start"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" パターン1：")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・TCMソフトウェア書き換え作業", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-start"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" パターン2：")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・TCMソフトウェア書き換え作業", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・モータ交換", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_16 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "text-start"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" パターン3：")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・TCMソフトウェア書き換え作業", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・モータ交換", -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・クラッチピストン交換", -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_26 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 3,
  class: "text-start"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" パターン4：")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・TCMソフトウェア書き換え作業", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・モータ交換", -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・クラッチピストン交換", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-bottom border-danger border-2" }, "・ポンプ交換", -1 /* HOISTED */))
const _hoisted_37 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "text-start border border-2 mt-5 fs-6" }
const _hoisted_39 = { class: "col-auto col-form-label" }
const _hoisted_40 = { class: "col-auto col-form-label" }
const _hoisted_41 = { class: "d-flex justify-content-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "最初に戻る", -1 /* HOISTED */))
const _hoisted_43 = [
  _hoisted_42
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.workPattern==='1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_8))
        : _createCommentVNode("v-if", true),
      ($setup.workPattern==='2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_16))
        : _createCommentVNode("v-if", true),
      ($setup.workPattern==='3')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_26))
        : _createCommentVNode("v-if", true),
      ($setup.workPattern==='4')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_37))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_39, "車台番号：" + _toDisplayString($setup.vinNo), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_40, "シリアル番号：" + _toDisplayString($setup.serialNo), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary mt-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.returnInitialPage()))
      }, _hoisted_43)
    ])
  ]))
}